/* eslint-disable quotes */

export const theme = {
    colors: {
        b40_darkgreen: "#00090A",
        b20_darkgreen: "#001213",
        darkgreen: "#002D30",
        w10_darkgreen: "#194245",
        w20_darkgreen: "#335759",
        w40_darkgreen: "#668183",
        w60_darkgreen: "#99ABAC",
        w80_darkgreen: "#CCD5D6",
        b40_brand_green: "#007646",
        b20_brand_green: "#009E5E",
        brand_green: "#00C575",
        w20_brand_green: "#57D371",
        w40_brand_green: "#81DE94",
        w60_brand_green: "#ABE9B8",
        w80_brand_green: "#D5F4DB",
        b20_light_green: "#009E5E",
        b80_silver: "#2C2D2E",
        b60_silver: "#585A5C",
        b40_silver: "#84888A",
        b20_sliver: "#B0B5B8",
        silver: "#DCE2E6",
        w40_silver: "#EAEEF0",
        w60_silver: "#F1F3F5",
        w80_silver: "#F8F9FA",
        white: "#FFFFFF",
        light90: "#EBEBEB",
        light80: "#D6D6D6",
        light70: "#C2C2C2",
        dark100: "#323232",
        dark80: "#5B5B5B",
        dark60: "#848484",
        dark40: "#ADADAD",
        b40_neon_fuchsia: "#99263F",
        b20_neon_fuchsia: "#CD3354",
        neon_fuchsia: "#FF4069",
        w20_neon_fuchsia: "#FF6586",
        w40_neon_fuchsia: "#FF8CA4",
        w60_neon_fuchsia: "#FFB3C4",
        w80_neon_fuchsia: "#FFD9E1",
        b40_mellow_yellow: "#99844F",
        b20_mellow_yellow: "#CDB069",
        mellow_yellow: "#FFDB83",
        w20_mellow_yellow: "#FFE29C",
        w60_mellow_yellow: "#FFF1CD",
        w80_mellow_yellow: "#FFF8E6",
        b40_brilliant_azure: "#1F5C99",
        b20_brilliant_azure: "#297ACC",
        brilliant_azure: "#3399FF",
        w20_brilliant_azure: "#5CADFF",
        w40_brilliant_azure: "#85C2FF",
        w60_brilliant_azure: "#ADD6FF",
        w80_brilliant_azure: "#D6EBFF",
        body_bg: "#F8F9FA",
        datePicker_lighter_green: "#66DCAC",
        datePicker_silver: "#f0f0f0",
        error_red: "#D90F0F",
    },
};

export const MIN_XS = '300px';
export const MAX_XS = '599px';
export const MIN_SM = '600px';
export const MAX_SM = '899px';
export const MIN_MD = '900px';
export const MAX_MD = '1199px';
export const MIN_LG = '1200px';
export const MAX_LG = '1440px';

export const blueActiveBorder = `
 box-shadow: 0px 0px 4px rgba(51, 153, 255, 0.5);
 border: 1px solid ${theme.colors.brilliant_azure};
`;
